import { Button } from "@similarweb/ui-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled from "styled-components";
import { i18nFilter } from "app/filters/i18nFilter";
import { useDispatch } from "react-redux";
import { AssetsService } from "app/services/AssetsService";
import { useCurrentStateAndParams } from "@uirouter/react";
import { showDurationFilterHof } from "app/actions/WebsiteAnalysisFilterActions";
import { periodOverPeriodService, PeriodOverPeriodService } from "app/services/PeriodOverPeriodService";
import { allTrackers } from "app/services/track/track";

const { blue, carbon } = colorsPalettes;

const Container = styled.div`
    background-color: ${blue[100]};
    display: flex;
    justify-content: space-between;
    padding: 0px 24px;
    border-radius: 4px;
    align-items: center;
`;
const Text = styled.span`
    ${setFontVariant("body2", carbon[500])}
`;

const ContentContainer = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
`;

export const PreDefinedIndustriesBenchmarkBanner = () => {
    const dispatch = useDispatch();
    const { params, state } = useCurrentStateAndParams();
    const { configId } = state;
    const { duration, comparedDuration } = params;
    const isPeriodOverPeriod = Boolean(comparedDuration);
    const openDatePicker = () => {
        allTrackers.trackEvent("Button", "click", "Period comparison/Cross industry overview");
        const showDurationFilter = showDurationFilterHof(dispatch);
        const isPeriodOverPeriodAllowed = periodOverPeriodService._periodOverPeriodEnabled(
            duration,
            duration,
            [],
            typeof configId === 'function' ? configId(state, {}) : configId,
        );
        const periodOverPeriodCompareType = isPeriodOverPeriodAllowed
            ? PeriodOverPeriodService.COMPARE_TYPES.PERIOD
            : null;
        showDurationFilter(periodOverPeriodCompareType);
    };
    const i18n = i18nFilter();
    if (isPeriodOverPeriod) {return null;}
    return (
        <Container>
            <ContentContainer>
                <img src={AssetsService.assetUrl(`/images/date-picker/calendar.svg`)} />
                <Text>{i18n("pre.defined.industries.benchmark.banner")}</Text>
            </ContentContainer>
            <Button onClick={openDatePicker}>{i18n("common.compare")}</Button>
        </Container>
    );
};
